const FilterSelect = ({
  label,
  options,
  value,
  onChange,
}: {
  onChange: (value: string) => void;
  label: string;
  options: { id: string; label: string }[];
  value?: string;
}) => {
  return (
    <div className="border border-gray-300 py-2 rounded-full px-3 flex flex-row gap-1 items-center justify-between">
      <span className="text-[12px] leading-4.5 font-bold text-brand-blue-600">
        {label}:
      </span>{" "}
      <select
        className="w-full"
        onChange={(e) => {
          const value = e.currentTarget.value;
          onChange(value);
        }}
        value={value}
      >
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FilterSelect;
